var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavuot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 31,
    viewBox: "0 0 15 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8DED1",
    d: "M13.563 0c-.167 0-.302.136-.302.303v2.945h-1.437c-2.593 0-4.695 2.106-4.695 4.703v2.045H9.17c2.593 0 4.695-2.105 4.695-4.704V.303c0-.167-.136-.303-.302-.303",
    transform: "translate(.554 .862)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M2.041 3.248H.605V.303C.605.136.47 0 .302 0 .136 0 0 .136 0 .303v4.989C0 7.89 2.102 9.996 4.695 9.996h2.041V7.951c0-2.597-2.102-4.703-4.695-4.703",
    transform: "translate(.554 .862)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8DED1",
    d: "M13.563 8.374c-.167 0-.302.136-.302.302v2.946h-1.437c-2.593 0-4.695 2.105-4.695 4.703v2.044H9.17c2.593 0 4.695-2.105 4.695-4.703v-4.99c0-.166-.136-.302-.302-.302",
    transform: "translate(.554 .862)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M2.041 11.622H.605V8.677c0-.168-.135-.303-.303-.303-.166 0-.302.135-.302.303v4.989c0 2.598 2.102 4.704 4.695 4.704h2.041v-2.045c0-2.597-2.102-4.703-4.695-4.703",
    transform: "translate(.554 .862)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8DED1",
    d: "M13.563 16.881c-.167 0-.302.136-.302.304v2.945h-1.437c-2.593 0-4.695 2.105-4.695 4.703v2.044H9.17c2.593 0 4.695-2.105 4.695-4.704V17.185c0-.168-.136-.304-.302-.304",
    transform: "translate(.554 .862)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M2.041 20.13H.605v-2.945c0-.168-.135-.304-.303-.304-.166 0-.302.136-.302.304V22.173c0 2.599 2.102 4.705 4.695 4.705h2.041v-2.045c0-2.598-2.102-4.704-4.695-4.704",
    transform: "translate(.554 .862)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M6.63 29.423h.605V.303C7.235.136 7.1 0 6.933 0c-.168 0-.303.136-.303.303v29.12z",
    transform: "translate(.554 .862)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavuot);
export default __webpack_public_path__ + "static/media/savuot.5301dfa51ab8c720de30f1e34b89f94f.svg";
export { ForwardRef as ReactComponent };